import { datesToISO, parseBoolean } from "@";

// search values payload for donations
export const searchValuesPayload = ({
  page,
  toDate,
  perSize,
  isStopped,
  fromDate,
  projectTitle,
}) => ({
  page: page,
  pageSize: perSize,
  toDate: datesToISO(toDate),
  fromDate: datesToISO(fromDate),
  isStopped: parseBoolean(isStopped),
  projectTitle: projectTitle,
});
